export class PromptMessage {
    title;
    body;
    confirmText;
    type;

    /**
     * Creates a prompt message object for use by Prompt.
     * @function
     * @memberof Prompt
     * @param {string} title Prompt title.
     * @param {string} body Prompt body.
     * @param {string} confirmText Prompt confirm button text.
     * @param {string} type Prompt modal color (info, warning).
     */
    constructor(title, body, confirmText, type) {
        this.title = title;
        this.body = body;
        this.confirmText = confirmText;
        this.type = type;
    }
}

export class Prompt {
    callback;
    deniedCallback;
    message;
    data;

    /**
     * Creates a prompt object for use by bo-confirmation.
     * @function
     * @param {function} callback Callback function when prompt succeeds.
     * @param {function|null} deniedCallback Callback function when prompt is denied.
     * @param {string} title Prompt title.
     * @param {string} body Prompt body.
     * @param {string} confirmText Prompt confirm button text.
     * @param {string} type Prompt modal color (info, warning).
     * @param {object|null} type Data needed in the callback.
     */

    constructor(callback, deniedCallback, title, body, confirmText, type, data = null) {
        this.callback = callback;
        this.deniedCallback = deniedCallback;
        this.message = new PromptMessage(title, body, confirmText, type);
        this.data = data;
    }
}
